document.addEventListener('DOMContentLoaded', function () {
  const gridImages = document.querySelectorAll('.blog-media-grid img');
  const lightbox = document.getElementById('blog-lightbox');
  const lightboxImage = document.getElementById('blog-lightbox-image');
  const closeBtn = document.querySelector('.blog-lightbox-close');

  if (!gridImages.length || !lightbox || !lightboxImage || !closeBtn) return;

  // OPEN
  gridImages.forEach((img) => {
    img.addEventListener('click', function () {
      lightboxImage.src = this.src;
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden'; 
    });
  });

  // CLOSE (button)
  closeBtn.addEventListener('click', closeLightbox);

  // CLOSE (click outside image)
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) {
      closeLightbox();
    }
  });

  // CLOSE (ESC key)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeLightbox();
    }
  });

  function closeLightbox() {
    lightbox.classList.remove('active');
    lightboxImage.src = '';
    document.body.style.overflow = ''; 
  }
});